import styled from 'styled-components';
import colors from '../../assets/colors';
import { Typography } from '../typography';

interface IProps {
	backgroundColor: keyof typeof colors;
	size: string;
	isBorder?: boolean;
	borderWidth?: number;
	borderColor: keyof typeof colors;
	hover?: keyof typeof colors;
	hoverText?: keyof typeof colors;
	color: keyof typeof colors;
}

const Button = styled.button<IProps>`
	width: ${p => (p.size === 'M' ? '48%' : '100%')};
	background-color: ${p => p.theme.colors[p.backgroundColor]};
	border: ${p => (p.isBorder ? p.borderWidth : 0)}px solid
		${p => p.theme.colors[p.borderColor]};
	z-index: 1;
	border-radius: 20px;
	height: 64px;
	justify-content: center;
	align-items: center;
	outline: none;

	&:hover {
		background-color: ${p =>
			p.hover
				? p.theme.colors[p.hover]
				: p.theme.colors[p.backgroundColor]} !important;

		span {
			color: ${p =>
				p.hoverText
					? p.theme.colors[p.hoverText]
					: p.theme.colors.white} !important;
		}
	}
`;

const Content = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Container = styled.div`
	padding: 0 15px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const Info = styled.div`
	display: flex;
	align-items: center;
`;

const StyledButtonText = styled(Typography)<{
	hover?: keyof typeof colors;
	color: keyof typeof colors;
}>`
	text-align: center;
	line-height: 26px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Button,
	Content,
	Container,
	Info,
	StyledButtonText,
};
